module.exports = __webpack_public_path__ + "static/media/zaha park shot 30.37fdf755.webp";